import React, { FC, useState, useEffect, useCallback } from 'react';
import styled from 'styled-components';
import { Modal, ModalProvider, ModalBox, ModalBackground } from '@cld/modal';
import { useAuth } from '../selectors';
import { LoginModalContent } from './demoPage/LoginModalContent';
import { Main } from './demoPage/Main';

export const DEMO_PAGE_WIDTH = 1380;

const Root = styled.div`
  width: ${DEMO_PAGE_WIDTH}px;
  margin: 0 auto;
`;

const NonRWDModalBackground = styled(ModalBackground)`
  position: absolute;
  min-width: ${DEMO_PAGE_WIDTH}px;
`;

const NonRWDModalBox = styled(ModalBox)`
  max-width: none;
  max-height: none;
`;

export const DemoPage: FC = () => {
  const auth = useAuth();
  const [loginModalOpen, setLoginModalOpen] = useState(false);
  const [prevBodyOverflow, setPrevBodyOverflow] = useState('');

  // I'm managing overflowY myself because @cld/modal only manages normal overflow
  const handleModalOpen = useCallback(() => {
    window.scrollTo({ top: 0 });
    setPrevBodyOverflow(document.body.style.overflowY);
    document.body.style.overflowY = 'hidden';
  }, []);
  const handleModalClose = useCallback(() => {
    setPrevBodyOverflow('');
    document.body.style.overflowY = prevBodyOverflow;
  }, [prevBodyOverflow]);

  useEffect(() => {
    if (!auth.cloudName && !loginModalOpen) {
      setLoginModalOpen(true);
    }
    if (auth.cloudName && loginModalOpen) {
      setLoginModalOpen(false);
    }
    return handleModalClose;
  }, [auth.cloudName, loginModalOpen, handleModalClose]);

  return (
    <Root>
      <ModalProvider WrapperComponent={NonRWDModalBox} BackgroundComponent={NonRWDModalBackground} allowScroll>
        <Main />
        <Modal isOpen={loginModalOpen} beforeOpen={handleModalOpen} afterClose={handleModalClose}>
          <LoginModalContent />
        </Modal>
      </ModalProvider>
    </Root>
  );
};
